// Shared markdown helpers for Help Center

export const slugify = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const extractText = (node) => {
  if (!node) return "";
  if (typeof node === "string") return node;
  if (Array.isArray(node)) return node.map(extractText).join("");
  if (node.children) return node.children.map(extractText).join("");
  return node.value || "";
};

export const extractToc = (markdown, levels = [2, 3]) => {
  if (!markdown) return [];
  const allowed = new Set(levels);
  const lines = String(markdown).split(/\r?\n/);
  const items = [];
  for (const line of lines) {
    const m = /^(#{1,6})\s+(.+)$/.exec(line.trim());
    if (m) {
      const level = m[1].length;
      if (allowed.has(level)) {
        const text = m[2].trim();
        const id = slugify(text);
        items.push({ level, text, id });
      }
    }
  }
  return items;
};

